//*
import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import WhatshotIcon from "@mui/icons-material/Whatshot";
//
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
import { useNavigate, useParams } from "react-router-dom";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
//import styles from "./User.module.css";
import { SerializedError } from "../../util/types";
import {
    FileMetadataItem,
    FileMetadataEditRequest,
    FileMetadataEditResponse,
} from "./fileSlice";
import { useFileViewQuery } from "../../api/file";
import { CardMedia } from "@mui/material";

let baseUrl: string;
switch (process.env.NODE_ENV) {
    case "development": {
        baseUrl = "/apidev";
        break;
    }
    case "test": {
        baseUrl = "/apidev";
        break;
    }
    case "production": {
        baseUrl = "/api";
        break;
    }
    default: {
        baseUrl = "/api";
        break;
    }
}

export default function Style() {
    let { id } = useParams();
    const idStr = id ? id : "";
    //const file = useAppSelector(selectTicket(idStr));
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useFileViewQuery(idStr, { refetchOnMountOrArgChange: true });
    let content: React.ReactNode;

    if (isLoading) {
        content = <ViewerLoading />;
    } else if (isFetching) {
        content = <ViewerFetching />;
    } else if (isSuccess) {
        content = <Viewer file={data} />;
    } else if (isError) {
        content = <ViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}

function Viewer({ file }: { file: FileMetadataEditResponse | null }) {
    if (file) {
        return <Display file={file} />;
    } else {
        return <>NO FILE SNIFF</>;
    }
}
function Display({ file }: { file: FileMetadataEditResponse }) {
    const isImage =
        file.file.extension.toLowerCase().endsWith("jpg") ||
        file.file.extension.toLowerCase().endsWith("jpeg") ||
        file.file.extension.toLowerCase().endsWith("gif") ||
        file.file.extension.toLowerCase().endsWith("png") ||
        file.file.extension.toLowerCase().endsWith("webp")
            ? true
            : false;
    return (
        <Box>
            <Card sx={{ minWidth: 275, maxWidth: 1200 }}>
                <CardContent>
                    <Typography
                        sx={{ fontSize: 10 }}
                        color="text.secondary"
                        gutterBottom
                    >
                        {file.file.metadata.created.ts}
                    </Typography>
                    <Typography variant="h6" component="div">
                        {file.file.name + "." + file.file.extension}
                    </Typography>
                    <Typography variant="body2">
                        page_id: {file.file.page_id}
                    </Typography>
                    <Link
                        component={RLink}
                        to={"/page/view/" + file.file.page_id}
                    >
                        page ({file.file.page_id})
                    </Link>{" "}
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                            baseUrl +
                            "/file/download/" +
                            file.file.metadata.id +
                            "." +
                            file.file.extension
                        }
                    >
                        Download ({file.file.metadata.id})
                    </a>{" "}
                    - <br />
                    <Link
                        component={RLink}
                        to={"/file/by-filter?page_id=" + file.file.page_id}
                    >
                        page files
                    </Link>
                    <br />
                    {Object.values(file.contacts).map((contact) => (
                        <Typography variant="body2">
                            {contact.first_name + " " + contact.last_name + " "}
                        </Typography>
                    ))}
                    - <br />
                    <br />
                    <Typography variant="body2">{file.file.content}</Typography>
                    {isImage && (
                        <CardMedia
                            component="img"
                            image={
                                baseUrl +
                                "/file/download/" +
                                file.file.metadata.id +
                                "." +
                                file.file.extension
                            }
                        />
                    )}{" "}
                </CardContent>
                <CardActions>
                    <Link
                        component={RLink}
                        to={"/file/edit/" + file.file.metadata.id}
                    >
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {}}
                        >
                            Edit
                        </Button>
                    </Link>
                </CardActions>
            </Card>
        </Box>
    );
}

export function ViewerLoading() {
    return <Box>Loading</Box>;
}

export function ViewerFetching() {
    return <Box>Fetching</Box>;
}

export function ViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}

export function ViewerSuccess({
    file,
}: {
    file: FileMetadataEditResponse | null;
}) {
    if (file) {
        return <Viewer file={file} />;
    } else {
        return <Box> Nothing </Box>;
    }
}
